export const admin = {
  // Gate states
  loading: '読み込み中...',
  deniedTitle: 'アクセス権限がありません',
  deniedBody: 'このアカウントは管理者として登録されていません。',
  logout: 'ログアウト',

  // Login
  login: {
    label: 'Admin',
    title: '管理者ログイン',
    email: 'メールアドレス',
    emailPlaceholder: 'admin@example.com',
    password: 'パスワード',
    passwordPlaceholder: 'パスワードを入力',
    submit: 'ログイン',
    submitting: 'ログイン中...',
    invalidCredentials: 'メールアドレスまたはパスワードが正しくありません',
  },

  // Dashboard header
  brandLabel: 'EachTeach Admin',
  title: 'サービス管理',
  backToHome: 'ホームへ',

  // Stats / actions
  publishedServices: '公開中のサービス',
  unit: '件',
  addNew: '新規追加',

  // Toasts
  toast: {
    updated: 'サービスを更新しました',
    updateFailed: '更新に失敗しました（権限または通信を確認）',
    added: 'サービスを追加しました',
    addFailed: '追加に失敗しました（権限または通信を確認）',
    deleted: 'サービスを削除しました',
    deleteFailed: '削除に失敗しました（権限または通信を確認）',
  },

  // Service list
  list: {
    empty: 'サービスがまだありません。「+ 新規追加」から作成してください。',
    edit: '編集',
    delete: '削除',
    confirmDelete: '「{{name}}」を削除しますか？',
    cancel: 'キャンセル',
    confirmDeleteButton: '削除する',
  },

  // Service form modal
  modal: {
    editTitle: 'サービスを編集',
    addTitle: '新しいサービスを追加',
    serviceName: 'サービス名',
    serviceNamePlaceholder: '例：EachTeach コミュニティ',
    shortDescription: '短い説明文',
    shortDescriptionPlaceholder: 'カードに表示される一言説明',
    detail: '詳細説明',
    detailPlaceholder: '「詳細を見る」で展開される詳しい説明（500字以内）',
    linkUrl: 'リンクURL（任意）',
    image: '画像',
    changeImage: '画像を変更する',
    clickToSelect: 'クリックして画像を選択',
    dragDrop: 'またはここにドラッグ＆ドロップ（JPG・PNG・WebP）',
    imageUploading: '画像をアップロード中...',
    imageTypeError: 'JPG・PNG・WebP 形式の画像を選択してください',
    imageSizeError: '画像サイズは 5MB 以内にしてください',
    imageUploadError: '画像のアップロードに失敗しました（権限または通信を確認）',
    cancel: 'キャンセル',
    update: '更新する',
    add: '追加する',
    requiredMark: '*',
  },
};
